import React from 'react'
import './DialogFullScreen.css'

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    button: {
        width: '100%',
        marginBottom: 20,
        textAlign: 'left',
    },
    content: {
        padding: 20,
    },
    dialogFullScreen: {
        maxWidth: 1200,
        margin: "auto",
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogFullScreen = (props) => {

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };


    return(
        <div>
            <Button variant="contained" size="large" color={props.colour} className={classes.button} onClick={handleClickOpen} endIcon={<KeyboardBackspaceIcon className="forwardIcon"/>}>
                {props.buttonText}
            </Button>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} className={classes.dialogFullScreen}>
                <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <KeyboardBackspaceIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {props.title}
                    </Typography>
                </Toolbar>
                </AppBar>
                <div className={classes.content} >
                    {props.content}
                </div>
            </Dialog>
        </div>
    )
}

export default DialogFullScreen;
